// extracted by mini-css-extract-plugin
export default {"mainContainer":"Login_mainContainer__h2yr+","mainHeading":"Login_mainHeading__10tKq"};